module.exports = __webpack_public_path__ + "static/media/bsc.5d27095a.svg";